import { useRef, useEffect } from 'react';

const testimonials = [
  {
    before: '頭ではわかってるんだけど変わらなくて。',
    after: 'わかってると思ってたけど、全然違ってた。',
  },
  {
    before: 'いつもどこか自分は間違ってる気がしてた。',
    after: '私、大丈夫だったんですね。',
  },
  {
    before: '全然変われてないと思ってた。',
    after: '変わってたんですね。',
  },
  {
    before: 'もう自分がどうしたいのかわからなくて。',
    after: 'もう過去は終わらせていいんですね。',
  },
  {
    before: '一人で学んできたけど、誰かと分かち合いたくなった。',
    after: 'まだ美那子さんと一緒にやりたい。',
  },
];

export default function TestimonialsSection() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-8');
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('.testimonial-card').forEach((c) => observer.observe(c));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="w-full bg-white py-24 px-4">
      <div className="max-w-3xl mx-auto">
        {/* Title */}
        <div className="testimonial-card opacity-0 translate-y-8 transition-all duration-1000 mb-16 text-center">
          <p className="font-sans text-[#8FA68B] text-xs tracking-[0.4em] mb-6 uppercase">voices</p>
          <h2 className="font-serif text-3xl md:text-4xl text-[#3A3530] leading-snug">
            クライアントの声
          </h2>
          <p className="font-sans text-[#8B8480] text-sm mt-4 tracking-wide">
            セッションを受けたかたの言葉より（許可を得て掲載）
          </p>
        </div>

        {/* Cards */}
        <div className="space-y-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="testimonial-card opacity-0 translate-y-8 transition-all duration-700 rounded-lg overflow-hidden"
              style={{ transitionDelay: `${i * 80}ms`, border: '1px solid #EDE7DC' }}
            >
              <div className="flex flex-col md:flex-row">

                {/* BEFORE */}
                <div
                  className="flex-1 p-6 md:p-8 flex flex-col justify-between"
                  style={{ backgroundColor: '#F8F4EF' }}
                >
                  <div>
                    <p className="font-sans text-xs text-[#C2A882] tracking-[0.35em] mb-4 uppercase">
                      before
                    </p>
                    <p className="font-sans text-[#6B6460] text-sm leading-loose">
                      &ldquo;{t.before}&rdquo;
                    </p>
                  </div>
                </div>

                {/* Arrow divider */}
                <div
                  className="flex items-center justify-center md:flex-col flex-row py-3 md:py-0 md:px-1 flex-shrink-0"
                  style={{ backgroundColor: 'rgba(143, 166, 139, 0.08)', minWidth: '44px' }}
                >
                  {/* mobile: down arrow, desktop: right arrow */}
                  <span className="text-[#8FA68B] text-base md:hidden">↓</span>
                  <span className="text-[#8FA68B] text-base hidden md:block">→</span>
                </div>

                {/* AFTER */}
                <div
                  className="flex-1 p-6 md:p-8 flex flex-col justify-between"
                  style={{ backgroundColor: 'rgba(143, 166, 139, 0.06)' }}
                >
                  <div>
                    <p className="font-sans text-xs text-[#8FA68B] tracking-[0.35em] mb-4 uppercase">
                      after
                    </p>
                    <p className="font-serif text-[#3A3530] text-base leading-loose">
                      &ldquo;{t.after}&rdquo;
                    </p>
                  </div>
                </div>

              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
